import { Typography } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
//import SectionHeader from "../../components/SectionHeader";
//import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import HighlightStats from "../../components/HighlightStats";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import { saveAs } from "file-saver";
import { formatPrice } from "../../utils/PriceFormatter";
import SearchBarFilter from "../../components/SearchBarFilter";

import {
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  downloadWithHoldingTaxReports,
  getWitholdingSummaryDetails,
  getWitholdingTaxDetails,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import {
  withholdingTaxColumnHeader,
} from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import * as CONSTANT from "../../constants/Constant";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import AmountDisplayTopHeader from "../../components/AmountDisplayTopHeader";
//import { CustomToolbar } from "../../components/DataGridCustomToolBar";
import { isEmptyArray } from "formik";
import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import { DownloadFileWithDatePickerSelectionDialog } from "../../components/DownloadFileWithDatePickerSelectionDialog";
//import { DownloadPayoutOnHoldReportNameSelectionDialog } from "../../components/DownloadPayoutOnHoldReportNameSelectionDialog";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'Company Name',
      displayName: 'Name',
      paramName: 'companyName',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Status',
    displayName: 'Status',
    paramName: 'status',
    isDateFilter: false,
    isSearchBarDropdown: true,
    searchBarDropdownOptions: [
      "Confirmed", 
      "Unconfirmed", 
      "Removed"
    ],
  },
  {
    keyValue: 'Company Code',
    displayName: 'Code',
    paramName: 'companyCode',
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Vendor Code',
    displayName: 'Vendor',
    paramName: 'vendorCode',
    isDateFilter: false,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },  
];

export function WitholdingTaxScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();

  //const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [witholdingTaxDetails, setWitholdingTaxDetails] = useState([]);
  const [withHoldingTaxSummary, setWithholdingTaxSummary] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [totalNoOfRows, setTotalNoOfRows] = useState(0); // Default height
  const [pageSize, setPageSize] = useState(15);
  const [downloadButtonVisible, setDownlaodButton] = useState(false);

  const [downloadFileDialogOpen, setDownloadFileDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    requestWitholdingTaxDetails(
      paginationModel.page, 
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  // pagination for Earmark
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });

  const filteredRows = witholdingTaxDetails.filter((row) =>
    Object.values(row).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  useEffect(() => {
    getWithholdingSummaryDetails();

    requestWitholdingTaxDetails(paginationModel.page, paginationModel.pageSize, selectedFilter, searchQuery);
  }, []);

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);

    updateButtonVisibility();
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, totalNoOfRows]);

  const updateButtonVisibility = () => {
    const sessionId = getFromLocalStorage(SESSION_ID);
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);

        let incentive = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize !== null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Incentive") {
                incentive = [...item.menuItem];
              }
            });

            incentive.forEach((itemA, index) => {
              if (itemA.menuName === "Withholding Tax") {
                const actionButtonList = [...itemA.actionButton];
                DebugLog(
                  "actionButtonList from sidebar    " +
                    JSON.stringify(actionButtonList)
                );

                actionButtonList.forEach((items, index) => {
                  if (items.buttonName === "DOWNLOAD") {
                    setDownlaodButton(true);
                  } else if (items.buttonName === "ADD NEW") {
                    //setAddNewButton(true)
                  } else if (items.buttonName === "VIEW") {
                    // set view only
                  } else if (items.buttonName === "EDIT") {
                    // set editable
                  }
                });
              }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  const handleRowClick = (params) => {
    // setSelectedItem(params.row);
    // setOpenSaveAndRemoveDialog(true);
    // requestWitholdingTaxDetails(timelineCurrentPage, params.row)
  };

  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });
    requestWitholdingTaxDetails(0, pageSize, filterParam, searchQuery);
  }

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    requestWitholdingTaxDetails(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    requestWitholdingTaxDetails(newPage, paginationModel.pageSize, selectedFilter, searchQuery);
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    // searchAllAccountEarmarkDetails(0, newPageSize);
    requestWitholdingTaxDetails(0, newPageSize, selectedFilter, searchQuery);
  };

  function requestWitholdingTaxDetails(pageNumber, pageSize, filterParam, searchQuery) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
            pageNumber,
            pageSize,
            filterParam,
            searchQuery
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_WITHHOLDING_DETAILS
        ).then((encryptedContentData) => {
          const onholdCompanyRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            contentData: encryptedContentData,
          };

          getWitholdingTaxDetails(onholdCompanyRequestData)
            .then((response) => {
              const contentData = response.data.result.content.map((row) => ({
                ...row,
                id: generateRandomId(),
              }));
              setWitholdingTaxDetails(contentData);
              //setTotalNoOfRows(response.data.result.content.length);

              setRowsPerPage(response.data.result.content.length);
              setTotalNoOfRows(response.data.result.totalElements);
              setTotalNoOfPages(response.data.result.totalPages);

              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response !== null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response !== null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  // Create Request Object for getEarMarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (selectedFilter !== null && selectedFilter !== undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue !== null && filterValue !== undefined && filterValue !== "") {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "name":
            requestObject.sortProperty = "WHT_COMPANY_NAME";
            break;
          case "status":
            requestObject.sortProperty = "WHT_STATUS";
            break;
          case "code":
            requestObject.sortProperty = "WHT_COMPANY_CODE";
            break;
          case "vendor":
            requestObject.sortProperty = "WHT_VENDOR_CODE";
            break;
          case "companyType":
            requestObject.sortProperty = "WHT_COMPANY_TYPE";
            break;
          case "payout":
            requestObject.sortProperty = "WHT_TOTAL_PAYOUT_AMOUNT";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  function getWithholdingSummaryDetails() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          payoutStartYear: "2024-07-31",
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_WITHHOLDING_TAX_DETAILS
        ).then((encryptedContentData) => {
          const onholdCompanyRequestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getWitholdingSummaryDetails(onholdCompanyRequestData)
            .then((response) => {
              // const contentData = response.data.result.earmarkDetails.content.map((row) => ({
              //   ...row,
              //   id: generateRandomId(),
              // }));
              setWithholdingTaxSummary(response.data.result);
              // setTotalNoOfRows(response.data.result.earmarkDetails.content.length);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else if (
                error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              ) {
                try {
                  navigate(CONSTANT.FINANCE_DASHBOARD);
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response !== null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response !== null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  function downloadWithholdingReport(fileType, startDate, endDate) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          reportTemplate: "WITHHOLDING_TAX_REPORT",
          reportFormat: fileType,
          //selectedDate:date
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.WITHHOLDING_TAX_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadWithHoldingTaxReports(requestData)
            .then((response) => {
              setLoading(false);


              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, "0");
              const month = String(currentDate.getMonth() + 1).padStart(2, "0");
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `Withholding_Tax_${year}-${month}-${day}`;
              switch (fileType) {
                case "CSV":
                  blob = new Blob([response.data], { type: "text/csv" });
                  filename = filename + ".csv";
                  break;
                case "XLS":
                  blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel",
                  });
                  filename = filename + ".xls";
                  break;
                case "PDF":
                  blob = new Blob([response.data], { type: "application/pdf" });
                  filename = filename + ".pdf";
                  break;

                default:
                  throw new Error("Invalid file type");
              }

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response !== null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  const openDownloadOptionsDialog = (type) => {
    if (isNetworkConnectionAvailable) {
    let title = "";
    if (type === "Download") {
      title = "Download";
    }
    setClickedButtonType(type);
    setDialogTitle(title);
    setDownloadFileDialogOpen(true);
  } else {
    showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
  }
  };

  const handleFileDownloadDialogClose = () => {
    setDownloadFileDialogOpen(false);
  };

  const handleFileDownloadSubmit = (fileType, type, startDate, endDate) => {
    if (type === "Cancel") {
      startDate = null;
      endDate = null;
    } else {
      downloadWithholdingReport(fileType, startDate, endDate);
    }
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container justifyContent="space-between">
            <Grid item>
              <GreetingHeader name={"Withholding Tax"}></GreetingHeader>
            </Grid>

            <Box position="absolute" right={25} top={60}>
              <SearchBarFilter
                filterProps={filterProps}
                onSearch={handleSearch}
              ></SearchBarFilter>
              </Box>

          </Grid>
          {/* Greetings Header */}

          {/* Highlight Stats */}
          <HighlightStats
            highlightTotal={AmountDisplayTopHeader(
              formatPrice(withHoldingTaxSummary.total)
            )}
            highlight1={"Interval"}
            highlight1Stat={withHoldingTaxSummary.interval}
            highlight2={"Dealers"}
            highlight2Stat={withHoldingTaxSummary.dealers}
            highlight3={"Confirmed"}
            highlight3Stat={withHoldingTaxSummary.confirmed}
            highlight4={"UnConfirmed"}
            highlight4Stat={withHoldingTaxSummary.unconfirmed}
          ></HighlightStats>
          {/* Highlight Stats */}

          {/*list Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={0}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"Withholding Tax"}
            ></SectionHeader> */}

            {witholdingTaxDetails.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  //rows={filteredRows.slice(
                  //   currentPage * pageSize,
                  //   (currentPage + 1) * pageSize
                  // )}
                  // columns={withholdingTaxColumnHeader}
                  // components={{ Toolbar: GridToolbar }}
                  // checkboxSelection
                  // selecion
                  // pageSize={pageSize}
                  // rowCount={filteredRows.length}
                  // pagination
                  // onPageChange={handlePageChange}

                  rows={witholdingTaxDetails}
                  columns={withholdingTaxColumnHeader}
                  // checkboxSelection = {false}
                  //selecion
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  pagination
                  onPageChange={handlePageChange}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]} // Include 10 in the options
                  autoHeight
                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {witholdingTaxDetails.length > 0 ? (
            <Box item mt={2} ml={1}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* list Section */}

          {/* Action Buttons */}

          {witholdingTaxDetails.length > 0 ? (
            <Grid item mt={1} justifyContent={"flex-start"} pb={10}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
                { downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadWithholdingReport}
                  />
                ) : (
                  ""
                )}
                {/* {downloadButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Download.svg" width={22} />
                    }
                    btnTxt={"Download"}
                    onClick={() => openDownloadOptionsDialog("Download")}
                  ></CustomButton>
                ) : (
                  ""
                )} */}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          {/* Action Buttons */}

          {/* Confirmation Dialog */}
          <DownloadFileWithDatePickerSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            type={clickedButtonType}
            title={dialogTitle}
          />

         {/* <DownloadPayoutOnHoldReportNameSelectionDialog
            open={downloadFileDialogOpen}
            handleClose={handleFileDownloadDialogClose}
            handleSubmit={handleFileDownloadSubmit}
            batchNo={"7"}
            type={clickedButtonType}
            title={dialogTitle}
          /> */}
          {/* Confirmation Dialog */}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
